var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28261 7.44871L13.7339 1.90975C14.0887 1.54946 14.0887 0.966927 13.7339 0.606641C13.3793 0.246354 12.806 0.246354 12.4514 0.606641L6.99992 6.1456L1.5486 0.606641C1.19384 0.246354 0.620668 0.246354 0.266072 0.606641C-0.0886906 0.966927 -0.0886906 1.54946 0.266072 1.90975L5.71739 7.44871L0.266072 12.9877C-0.0886906 13.348 -0.0886906 13.9305 0.266072 14.2908C0.442789 14.4705 0.675145 14.5608 0.907335 14.5608C1.13953 14.5608 1.37172 14.4705 1.5486 14.2908L6.99992 8.75182L12.4514 14.2908C12.6283 14.4705 12.8605 14.5608 13.0927 14.5608C13.3249 14.5608 13.557 14.4705 13.7339 14.2908C14.0887 13.9305 14.0887 13.348 13.7339 12.9877L8.28261 7.44871Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fa51d73261851b9a916909264cc647fa.svg";
export { ForwardRef as ReactComponent };